import React from 'react';

import { useFormik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';

import { FormInputPin } from 'modules/common/input';
import PageTitle from 'modules/common/components/PageTitle';
import ErrorLabel from 'modules/common/components/ErrorLabel';

import { useValidateOTP } from '../hooks';
import Brand from '../../partial/components/Brand';
import InfoGraphic from '../components/InfoGraphic';

const INIT_FORM = {
  pin: '',
};

function OTPValidation() {
  document.body.className = 'overflow-hidden';
  const history = useHistory();
  const { search } = useLocation();
  const order_number = search?.split('=')[1];
  const [, validate] = useValidateOTP();

  const [validation, setValidation] = React.useState(false);

  const { handleSubmit, setFieldValue, values, errors, submitForm } = useFormik(
    {
      initialValues: INIT_FORM,
      enableReinitialize: true,
      validateOnChange: validation,
      validateOnBlur: validation,
      onSubmit: (payload) => {
        validate(order_number, payload, () => {
          history.push(`/r/order_details/${order_number}/${payload?.pin}`);
        });
      },
    }
  );

  React.useEffect(() => {
    if (values?.pin?.length === 6) {
      setValidation(true);
      submitForm();
    }
  }, [submitForm, values?.pin?.length]);

  return (
    <>
      <PageTitle title="PEP | OTP Validation" />
      <div className="h-full">
        <div className="flex h-full px-3">
          <div className="m-auto mb-10">
            <div className="flex justify-center">
              <Brand className="h-8" />
            </div>
            <div className="text-center mt-10 md:mt-14">
              <h4 className="text-2xl md:text-3xl font-bold">OTP Number</h4>
              <p className="text-gray-500 text-sm">
                Please enter OTP number sent via sms
              </p>
            </div>
            <form
              className="mt-8 relative"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
                setValidation(true);
              }}
              noValidate
            >
              <div className="relative z-10">
                <FormInputPin
                  name="pin"
                  error={errors?.pin}
                  value={values?.pin}
                  onSetFieldValue={setFieldValue}
                  required
                  pinClassName="w-14 xs:h-14 h-16 rounded-md text-gray-800 border text-3xl font-bold"
                  inActivePinClassName="border-gray-300 bg-gray-50"
                  activePinClassName="ring-2 ring-primary-500 bg-white"
                />
              </div>
              <div className="mt-3">
                <ErrorLabel error={errors?.order_number} />
              </div>
            </form>
            <InfoGraphic />
          </div>
        </div>
      </div>
    </>
  );
}
OTPValidation.defaultProps = {};

OTPValidation.propTypes = {};

export default OTPValidation;
